import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const providerGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verifica se o usuário está autenticado
  if (!authService.isAuthenticated()) {
    router.navigate(['/']);
    return false;
  }

  // Verifica se o usuário é um provider
  if (!authService.isProvider()) {
    router.navigate(['/']);
    return false;
  }

  // Verifica se o provider tem associação
  if (!authService.hasProviderAssociated()) {
    // Provedor sem associação pode acessar o dashboard para ver status de aprovação
    return true;
  }

  // Verifica se o provider está verificado
  if (!authService.isProviderVerified()) {
    // Provedor não verificado pode acessar o dashboard para ver status de aprovação
    return true;
  }

  return true;
};
